import axios from 'axios'
import {Loading, Message} from "element-ui";
import utils from "@/utils/utils";
import Cookies from "js-cookie";

let baseURL = process.env.NODE_ENV === 'development' ? '/api' : window.location.protocol + '//' + window.location.hostname

export const request = axios.create({
  baseURL: baseURL + '/back',
  timeout: 80000,
  headers: {
    'Content-Type': 'application/json',
  },
})
request.interceptors.request.use(config => {
  config.headers.Authorization = JSON.parse(Cookies.get(utils.getTokenKey()) || null)?.yzb?.yzbToken
  // config.headers.terminal = 1
  return config
}, error => {
  return Promise.reject(error)
})
request.interceptors.response.use(response => {
  const res = response.data;
  if (res.status !== 200) {
    // 响应数据为Blob处理(Excel导出)
    if (res instanceof Blob) {
      return res
    }
    Message.error(res.message || "发生错误")
    if ([401].includes(res.status)) {
      utils.logout()
    }
    return Promise.reject(new Error(res.message || "发生错误"));
  } else {
    // console.log('🚀', response.request.responseURL + '\n', res.data)
    return res.data;
  }
}, error => {
  return Promise.reject(error)
})

/**
 * GET
 * @param url
 * @param params
 * @returns {Promise<[*,*]>}
 */
export function get(url, params = {}) {
  return new Promise(resolve => {
    request.get(url, {params}).then(res => {
      resolve([null, res])
    }).catch(err => {
      resolve([err, undefined])
    })
  })
}

/**
 * POST
 * @param url
 * @param data
 * @returns {Promise<[*,*]>}
 */
export function post(url, data = {}, config) {
  return new Promise(resolve => {
    request.post(url, data, config).then(res => {
      resolve([null, res])
    }).catch(err => {
      resolve([err, undefined])
    })
  })
}

/**
 * 上传file
 * @param {string} url 上传文件接口
 * @param {Object} data 提交的数据
 */
let formDataHeader = {'Content-Type': 'multipart/form-data'}

export function uploadFiles(url, data) {
  let loadingInstance = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  let formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })
  return new Promise(resolve => {
    request.post(url, formData, {headers: formDataHeader}).then(res => {
      resolve([null, res])
    }).catch(err => {
      resolve([err, undefined])
    }).finally(() => {
      loadingInstance.close();
    })
  })
}